// extracted by mini-css-extract-plugin
export var bounce = "_ow-1";
export var generatingText = "_ow-6";
export var lightning = "_ow-4";
export var popup = "_ow-5";
export var progressBar = "_ow-7";
export var progressFill = "_ow-8";
export var progressShimmer = "_ow-9";
export var progressText = "_ow-a";
export var shimmer = "_ow-3";
export var uploadIcon = "_ow-0";
export var uploadingText = "_ow-2";